const storageTypes = {
  LOCALSTORAGE: 'Local Storage',
  SESSIONSTORAGE: 'Session Storage'
};

export default storageTypes;
